<div class="container">

    <p class="txt_nome_escola">{{ nome_escola }}</p>

    <app-stepper [recebeAba]="aba"></app-stepper>
    <form [formGroup]="form">
        <mat-card class="card">
            <mat-card-content>
                <p>Informe o nome do(s) aluno(s), selecione uma série e clique no botão para adicionar.</p>

                <mat-form-field class="input-40 mr-3">
                    <mat-label>Nome do aluno(a)</mat-label>
                    <input matInput formControlName="nome_dependente">
                    <mat-error *ngIf="isInvalid('nome_dependente')">
                        {{ mensagemDeErro('nome_dependente') }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="input-40 mr-5">
                    <mat-label>Escolha a série do aluno(a)</mat-label>
                    <mat-select formControlName="id_serie">
                        <mat-option *ngFor="let ano of anos" [value]="ano.id_serie">{{ ano.descricao }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="isInvalid('id_serie')">
                        {{ mensagemDeErro('id_serie') }}
                    </mat-error>
                </mat-form-field>

                <button mat-fab color="primary" class="btn-add" matTooltip="Adicionar aluno" (click)="addDependente(form)">
                          <mat-icon class="mat-18 ">add</mat-icon>
                    </button>

                <div *ngIf="dataSource && dataSource.data && dataSource.data.length > 0">

                    <div *ngIf="isLoading" class="loading">
                        <mat-spinner></mat-spinner>
                    </div>

                    <table mat-table class="table" [dataSource]="dataSource" matSort *ngIf="!isLoading">
                        <ng-container matColumnDef="nome_dependente">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                            <td mat-cell *matCellDef="let row">{{ row.nome_dependente }}</td>
                        </ng-container>
                        <ng-container matColumnDef="id_serie">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Série
                            </th>
                            <td mat-cell *matCellDef="let row">{{ row.serie.descricao }}</td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Ações</th>
                            <td mat-cell *matCellDef="let row">
                                <button type="button" mat-icon-button matTooltip="Excluir aluno" color="warn" (click)="deletaDependente(row.id)">
                          <mat-icon class="mat-18">delete</mat-icon>
                        </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>
            </mat-card-content>

            <mat-card-actions>
                <button mat-raised-button color="primary" (click)="continuar()">CONTINUAR</button>

            </mat-card-actions>
        </mat-card>
    </form>
</div>